module.exports={"wireguard adapter settings":"Adaptereinstellungen für wireguard",option1:"Option 1",option2:"Option 2"};